import React, { useState, useEffect, useMemo, useContext } from 'react';
import { message, Col, Row, Select, Carousel, Divider, Checkbox } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { AppContext } from '@utils/AppContext';
import styles from './index.module.scss'
import { GenerateContext } from '@utils/GenerateContext';
import { IMAGE_TYPE } from "@utils/CONST"
import API from '@api/api'

const ModelFilterSelect = (props) => {
    const { globalUser } = useContext(AppContext);
    const [skin, setSkin] = useState([]);
    const [sex, setSex] = useState([]);
    const [age, setAge] = useState([]);
    const [clothesCate, setClothesCate] = useState([]);
    const [algoModelType, setAlgoModelType] = useState([]);
    const [posture, setPosture] = useState([])
    const [clothesCateOpts, setClothesCateOpts] = useState([])

    useEffect(() => {
        setSkin([...props.filterValue?.skin || []])
        setSex([...props.filterValue?.sex || []])
        setAge([...props.filterValue?.age || []])
        setClothesCate([...props.filterValue?.clothesCate || []])
        setAlgoModelType([...props.filterValue?.algoModelType || []])
        setPosture([...props.filterValue?.posture || []])
    }, [props.filterValue])

    const optFactory = (opt, placeholder) => {
        return {
            mode: "multiple",
            allowClear: true,
            showSearch: false,
            style: { width: props.width || props.showLabel ? 'calc(100% - 60px)' : '100%' },
            size: 'small',
            maxTagCount: 'responsive',
            placeholder: placeholder,
            options: opt
        }
    }

    const sexOpts = [{
        value: 'female',
        label: '女',
    }, {
        value: 'male',
        label: '男',
    }]

    const ageOpts = [{
        value: 'adult',
        label: '成年',
    }, {
        value: 'children',
        label: '儿童',
        // },  {
        //     value: 'oldman',
        //     label: '老年',
    }]

    const skinOpts = [{
        label: '黄',
        value: 'yellow',
    }, {
        label: '白',
        value: 'white',
    }, {
        label: '黑',
        value: 'black',
        // }, {
        //     label: '棕',
        //     value: 'brown',
    }]

    const algoModelTypeOpts = [{
        value: 'hsf',
        label: 'HSF',
    }, {
        value: 'lora',
        label: 'Lora',
    }, {
        value: 'constant_id',
        disabled: !isMembership,
        label: 'ConstID',
    }]

    const shoesCategoryList = () => {
        API.shoesCategoryList({
            category: 'clothesCate',
            resourceType: 'tryon',
        }).then(res => {
            if (res.code != 0) throw new Error(res.message)
            const list = res.data.map(item => ({ label: item.display, value: item.value }))
            setClothesCateOpts(list || [])
        }).catch(err => {
            message.error(err.message)
        }).finally(() => {
            console.log('finally')
        })
    }

    const handleChange2 = (value, key) => {
        switch (key) {
            case 1:
                // setSex([...value])
                props.onChange({ sex: [...value] })
                break;
            case 2:
                // setAge([...value])
                props.onChange({ age: [...value] })
                break;
            case 3:
                // setSkin([...value])
                props.onChange({ skin: [...value] })
                break;
            case 4:
                // setPosture([...value])
                props.onChange({ posture: [...value] })
                break;
            case 5:
                // setAlgoModelType([...value])
                props.onChange({ algoModelType: [...value] })
                break;
            case 6:
                // setAlgoModelType([...value])
                props.onChange({ clothesCate: [...value] })
                break;
        }
    }

    const tagRender = (props) => {
        const { label } = props;
        return <span className={styles.ModelFilterSelect_tag}>{label}</span>
    }


    const isMembership = useMemo(() => {
        return globalUser?.membership?.plan != '免费版'
    })

    const showClothesCate = useMemo(() => {
        return props.imageType == IMAGE_TYPE.CLOTHES && props.isPose
    }, [props.imageType, props.isPose])

    const colSpan = useMemo(() => {
        return (props.imageType == IMAGE_TYPE.CLOTHES && props.isPose) ? 6 : 8
    }, [props.imageType, props.isPose])

    useEffect(() => {
        if (showClothesCate) shoesCategoryList()
    }, [showClothesCate])

    return (
        <Row className={styles.ModelFilterSelect} style={{ maxWidth: '800px' }} gutter={10}>
            {
                !props.showLabel &&
                <>
                    <Col span={colSpan}>
                        {props.showLabel && <label htmlFor="modal-sex">性别</label>}
                        <Select id='modal-sex' {...optFactory(sexOpts, '性别')} value={sex} onChange={v => handleChange2(v, 1)} tagRender={tagRender} />
                    </Col>
                    <Col span={colSpan}>
                        {props.showLabel && <label htmlFor="modal-skin">肤色</label>}
                        <Select id='modal-skin' {...optFactory(skinOpts, '肤色')} value={skin} onChange={v => handleChange2(v, 3)} tagRender={tagRender} />
                    </Col>
                    <Col span={colSpan}>
                        {props.showLabel && <label htmlFor="modal-age">年龄</label>}
                        <Select id='modal-age' {...optFactory(ageOpts, '年龄')} value={age} onChange={v => handleChange2(v, 2)} tagRender={tagRender} />
                    </Col>
                    {
                        showClothesCate && <Col span={colSpan}>
                            {props.showLabel && <label htmlFor="modal-age">服饰品类</label>}
                            <Select id='modal-age' {...optFactory(clothesCateOpts, '服饰品类')} value={clothesCate} onChange={v => handleChange2(v, 6)} tagRender={tagRender} />
                        </Col>
                    }

                    {/* {
                        (props.imageType == IMAGE_TYPE.MODEL || props.imageType == IMAGE_TYPE.CLOTHES) && <Col span={6}>
                            {props.showLabel && <label htmlFor="modal-algoModel">模特类型</label>}
                            <Select id='modal-algoModel' {...optFactory(algoModelTypeOpts, '模特类型')} value={algoModelType} onChange={v => handleChange2(v, 5)} tagRender={tagRender} />
                        </Col>
                    } */}


                </>
            }
        </Row>
    )
}

export default ModelFilterSelect